'use client';

import type { ButtonHTMLAttributes } from 'react';
import { googleSignInAssets } from './googleSignInAssets';
import './google-signin-button.css';

type Props = ButtonHTMLAttributes<HTMLButtonElement>;

/** Branded "Sign in with Google" using official assets in /public/signin-assets-google. */
export function GoogleSignInButton({ disabled, className, ...props }: Props) {
  return (
    <button
      type="button"
      className={['google-signin-button', className].filter(Boolean).join(' ')}
      disabled={disabled}
      {...props}
    >
      <picture>
        <source srcSet={googleSignInAssets.signInDark} media="(prefers-color-scheme: dark)" />
        <img
          className="google-signin-button__img"
          src={googleSignInAssets.signInLight}
          alt="Sign in with Google"
          width={175}
          height={40}
          draggable={false}
        />
      </picture>
    </button>
  );
}
